module.exports = __webpack_public_path__ + "img/lsyhreg.da246fc2.png";